import React from 'react'
import {StoredIndividualization} from "../../../types/Individualization";
import {useTranslation} from "react-i18next";
import {useGlobalContext} from "../../../contexts/globalContext";
import {AxiosResponse} from "axios";
import Button from "../../../components/Button";
import Text from "../../../components/Text";
import {useDeleteData} from "../../../hooks/useDeleteData";
import {htmlToText} from "../../../helpers/htmlToText";

type DeleteIndividualizationModalProps = {
    individualization: StoredIndividualization;
    onSubmit: () => void;
}

const DeleteIndividualizationModal: React.FC<DeleteIndividualizationModalProps> = (
    {
        individualization,
        onSubmit
    }
) => {
    const { t } = useTranslation(['individualization'])
    const { closeModal, showToast } = useGlobalContext()
    const { submit } = useDeleteData('individualization', individualization.id)

    const handleSubmit = () => {
        submit().then((res: AxiosResponse) => {
            if (res.status === 204) {
                closeModal()
                showToast('top-right', 'success', t('overview.delete_modal.success'))
            } else {
                showToast('top-right', 'error', t('overview.delete_modal.error'))
            }
            onSubmit()
        })
    }

    return (
        <div className={'d-flex align-items-center justify-content-between flex-column'}>
            <Text>
                {t('overview.delete_modal.sub_heading', {article_name: htmlToText(individualization?.article?.cName ?? individualization?.kArtikel)})}
            </Text>
            <Button
                hierarchy={'primary'}
                text={t('overview.delete_modal.action')}
                fn={() => handleSubmit()}
                classes={'w-100 mx-4 my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('overview.delete_modal.abort')}
                fn={() => closeModal()}
                classes={'w-100 mx-4 my-2'}
            />
        </div>
    )
}

export default DeleteIndividualizationModal
